module.exports = __webpack_public_path__ + "img/md-chatboxes.91b10fb5.svg";